<template>
  <div class="setSheetCompute">
    <div class="contentItem">
      <div class="itemTitle">选择运算日期/时间</div>
      <SetValue
        type="time"
        :workflow-var-list="workflowVarList"
        :info="tempNodeInfo.extra"
        @updateInfo="updateExtra"
      ></SetValue>
    </div>
    <div class="contentItem">
      <div class="itemTitle" style="padding-bottom: 10px">
        选择运算时的日期格式
        <el-tooltip effect="dark" placement="bottom" content="">
          <div slot="content">
            如：可以将 2019/11/11 12:23 格式化为“日期”，
            <br />
            以 2019/11/11 参与运算。+8h后，得到时间结果：
            <br />
            2019/11/11 8:00。
          </div>
          <i class="el-icon-question"></i>
        </el-tooltip>
      </div>
      <NormalSelect
        size="normal"
        :selectList="dateFormat"
        :selectedItem.sync="tempNodeData.format"
      ></NormalSelect>
    </div>
    <div class="contentItem">
      <div class="itemTitle">运算</div>
      <div class="titleTip">
        对所选的运算日期 添加/减去 的时间(添加时间写正数，减去时间写负数)
      </div>

      <el-row :gutter="20" class="mTop10">
        <el-col :span="8" class="column">
          <div class="label">年：</div>
          <el-input v-model="tempNodeData.value.years" size="medium" type="number"></el-input>
        </el-col>
        <el-col :span="8" class="column">
          <div class="label">月：</div>
          <el-input v-model="tempNodeData.value.months" size="medium" type="number"></el-input>
        </el-col>
        <el-col :span="8" class="column">
          <div class="label">日：</div>
          <el-input v-model="tempNodeData.value.days" size="medium" type="number"></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20" class="mTop10">
        <el-col :span="8" class="column">
          <div class="label">时：</div>
          <el-input v-model="tempNodeData.value.hours" size="medium" type="number"></el-input>
        </el-col>
        <el-col :span="8" class="column">
          <div class="label">分：</div>
          <el-input v-model="tempNodeData.value.minutes" size="medium" type="number"></el-input>
        </el-col>
        <el-col :span="8" class="column">
          <div class="label">秒：</div>
          <el-input v-model="tempNodeData.value.seconds" size="medium" type="number"></el-input>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import SetValue from "../../components/SetValue-workFlow"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import { deepClone } from "@/utils/common"
import { filterTreeVarGroup } from "@/utils/workFlow"
import { bfs } from "@/utils/algorithm"
import dj from "dayjs"
export default {
  name: "setDateCompute",
  components: {
    NormalSelect,
    SetValue
  },
  props: {
    workflowVarGroup: Array,
    nodeInfo: Object,
    extra: Object
  },
  watch: {
    tempNodeData: {
      immediate: true,
      handler() {
        if (!this._.isEmpty(this.tempNodeInfo)) {
          let expression =
            (this.tempNodeInfo.data.start === "NOW"
              ? "系统当前时间"
              : dj(this.tempNodeInfo.data.start).isValid()
              ? this.tempNodeInfo.data.start
              : this.workFlowInfo?.[this.tempNodeInfo.data.start]) +
            this.getDateExpression("年", this.tempNodeInfo.data.value.years) +
            this.getDateExpression("月", this.tempNodeInfo.data.value.months) +
            this.getDateExpression("日", this.tempNodeInfo.data.value.days) +
            this.getDateExpression("时", this.tempNodeInfo.data.value.hours) +
            this.getDateExpression("分", this.tempNodeInfo.data.value.minutes) +
            this.getDateExpression("秒", this.tempNodeInfo.data.value.seconds)
          if (this.tempNodeInfo.data.start && !expression.includes("undefined")) {
            this.$set(this.extra, "description", {
              expression: expression
            })
          }
        }
      },
      deep: true
    }
  },
  data() {
    return {
      tempNodeData: {},
      tempNodeInfo: {},
      dateFormat: [
        { label: "年", value: "年" },
        { label: "年月", value: "年月" },
        { label: "年月日", value: "年月日" },
        { label: "年月日时", value: "年月日时" },
        { label: "年月日时分", value: "年月日时分" },
        { label: "年月日时分秒", value: "年月日时分秒" }
      ]
    }
  },
  computed: {
    workflowVarList() {
      return filterTreeVarGroup({
        varGroup: this.workflowVarGroup,
        filterFunc: ({ control }) => control?._type === "time"
      })
    },
    workFlowInfo() {
      let map = {}
      bfs({
        arr: this.workflowVarList,
        childFuc: group => group.children,
        cbk: group => {
          group.options.forEach(option => (map[option.value] = option.label))
        }
      })
      return map
    }
  },
  created() {
    this.tempNodeInfo = deepClone(this.nodeInfo)
    this.tempNodeData = this.tempNodeInfo.data
  },
  methods: {
    updateExtra($event) {
      this.$set(this.extra, "inFlow", $event.inFlow)
      this.$set(this.extra, "label", $event.label)
      this.$set(this.extra, "value", $event.value)
      this.tempNodeInfo.data.start = $event.value
    },
    getDateExpression(unit, value) {
      let result = ""
      if (value < 0) {
        result = " - " + -value + unit
      }
      if (value > 0) {
        result = " + " + value + unit
      }
      return result
    }
  }
}
</script>

<style lang="scss">
.setSheetCompute {
  .contentItem {
    .el-input__inner {
      border-width: 1px;
    }
    .column {
      display: flex;
      align-items: center;
      .label {
        padding-right: 5px;
      }
    }
  }
}
</style>
